import React, { useState, useEffect } from 'react'
import { getAppliedCOuntStatsByRefrneceDate,getDisbursedStatsRefrenceByDateLead } from '../ActionCreator'
import Loader from '../../../../../../presentationals/Loader/Loader.component'
import moment from 'moment';
import TuneIcon from '@mui/icons-material/Tune';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { Pagination } from "@mui/material";

export default function DisbursedLeadList({ Data }) {
    const [loader, setLoader] = useState(false);

     const [totalDisbursedLeads, setTotalDisbursedLeads] = useState('');
     const [page, setPage] = useState(1);
     const [count, setcount] = useState(10);
     const [objectData, setObjectData] = useState('')
    const [payload, setPayload] = useState({
        filter: "Daily",
        fromDate: moment(new Date()).format("YYYY-MM-DD"),
        toDate: moment(new Date()).format("YYYY-MM-DD"), 
        loanStatus: [
    "107",
    "109",
    "114",
    "119"
]
    })

    useEffect(() => {
        applyFilter()
    }, [])

    const handleChange = (e, type) => {
        setPayload((prev) => ({
            ...prev,
            [type]: e.target.value
        }))
    }

    const changeHandler =(event,value)=>{
        setPage(value)
        getAppliedCOuntStatsByRefrneceDateFn(value)
    }

    const applyFilter = () => {
        getAppliedCOuntStatsByRefrneceDateFn(page)
        getDisbursedStatsRefrenceByDateLeadFn()
    }

    const getAppliedCOuntStatsByRefrneceDateFn = (currentPage) => {
        setLoader(true)
        const start = moment(payload?.fromDate)?.format("DD-MM-YYYY")
        const end = moment(payload?.toDate)?.format("DD-MM-YYYY")
        getAppliedCOuntStatsByRefrneceDate(start, end, Data?.referenceCode,currentPage,count,payload?.loanStatus, Callback => {
            setLoader(false)
            setObjectData(Callback)
        })
    }
    const getDisbursedStatsRefrenceByDateLeadFn = () => {
        setLoader(true)
        const start = moment(payload?.fromDate)?.format("DD-MM-YYYY")
        const end = moment(payload?.toDate)?.format("DD-MM-YYYY")
        getDisbursedStatsRefrenceByDateLead(start, end, Data?.referenceCode, Callback => {
            setLoader(false)
            setTotalDisbursedLeads(Callback?.count)
        })
    }

    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            <div className="container-fluid marketing-main-css" style={{ marginTop: '20px' }}>
                <div className="row">
                    <div className="col-sm-2 col-xs-12">
                        <TuneIcon />
                        <span className="ms-3 filterHeaders">Filter</span>
                        <select
                            name=""
                            id=""
                            value={payload.filter}
                            className="form-select"
                            onChange={(e) => handleChange(e, "filter")}
                            style={{ width: '100%', padding: '10px', color: '#000' }}
                        >
                            <option value="daily">Daily</option>
                        </select>
                    </div>

                    <div className="col-sm-2 col-xs-12">
                        From
                        <input
                            type="date"
                            id="startDate"
                            placeholder="DD/MM/YY"
                            name="fromDate"
                            value={payload.fromDate}
                            onChange={(e) => handleChange(e, "fromDate")}
                            className=" form-control"
                            style={{
                                border: "1px solid gray",
                                borderRadius: "6px",
                                padding: "10px",
                            }}
                        />

                    </div>


                    <div className="col-sm-2 col-xs-12">
                        <div className="filterHeaders" style={{ marginTop: '4px' }}>to</div>
                        <input
                            type="date"
                            id="endDate"
                            name="toDate"
                            value={payload.toDate}
                            onChange={(e) => handleChange(e, "toDate")}
                            placeholder="DD/MM/YY"
                            className=" form-control"
                            style={{
                                border: "1px solid gray",
                                borderRadius: "6px",
                                padding: "10px",
                            }}
                        />
                    </div>
                    <div className="col-sm-2 col-xs-12">
                        <button
                            className="btn btn-primary mt-4 "
                            style={{
                                marginTop: '27px',
                                padding: '9px',
                                borderRadius: '5px'
                            }}
                            onClick={() => applyFilter()}
                        >
                            Apply Filter
                        </button>
                    </div>

                </div>

                <hr />
                <div
                    className="mt-2"
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                    }}
                >
                    <div className="d-inline-flex" style={{ display: 'flex' }}>
                        <FormatListBulletedIcon /> &nbsp;&nbsp;
                        <h4 className="ms-3 leadBreakDown_Header">Disbursed Lead List</h4>
                    </div>
                    <h6 className="disbursedHeader">
                        Total Disbursed Leads :{" "}
                        <span className="disbursedAmountHeader">
                            {totalDisbursedLeads || "  "}
                        </span>
                    </h6>
                </div>
                <div className='credit-table'>
                    <table>
                        <thead style={{ background: '#b9d8f9', color: '#000' }}>
                            <tr className="thead-class">
                                <th className="">Lead Name</th>
                                <th className="">Application ID</th>
                                <th className="">Mobile Number</th>
                                <th className="">Approved Amount</th>
                                <th className="">Loan Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {objectData !== '' && objectData !== undefined ? objectData.map((data, i) => {
                                return (
                                    <tr style={{ borderBottom: "none" }}>
                                        <td scope="col">
                                            {data.leadName}
                                        </td>
                                        <td>{data.applicationId}</td>
                                        <td>{data.mobileNumber}</td>
                                        <td>{data.loanApproveAmount}</td>
                                        <td>{data.adminStatus}</td>

                                    </tr>
                                )
                            }) : ""}

                        </tbody>
                    </table>
                </div>
                <div className="row">


                    <div className="col-sm-8"></div>

                    <div className="col-sm-4"> <div style={{ float: 'right', marginTop: '10px', marginBottom: '10px', marginRight: '40px' }}>
                        <Pagination count={Math.ceil(totalDisbursedLeads / count)} color="primary"
                            shape="circle"
                            onChange={changeHandler}
                        />
                    </div></div>
                </div>

            </div>
        </>
    )
}
